<template>
  <div
    class="audio-item-generate-box"
    :class="{
      [`audio-item-generate-box--${createRenderType}`]: true,
      'audio-item-generate-box-first': props.index == 0,
    }"
  >
    <div class="audio-item-generate">
      <div class="audio-item-box-loading rotate-loading">
        <!-- <LoaderCircle
          :loading="true"
          :size="20"
          color="#94ADFF"
          :marginSize="2"
          :strokeWidth="2"
        ></LoaderCircle> -->
      </div>
      <div
        class="audio-item-box-waiting-text flex1 width-0"
        v-if="props.pitem?.state == 1"
      >
        <span class="block">
          {{
            $$t("create.wate_num_in_queue").replace(
              "[wait_num]",
              props.pitem?.wait_num ?? 1
            )
          }}
        </span>
      </div>
      <div
        class="audio-item-box-waiting-text flex1 width-0"
        v-show="props.pitem?.state == 2"
      >
        {{ $$t("create.generating") }}
      </div>

      <div class="audio-item-box-btns">
        <div class="fn-inline audio-item-box-btn">
          <Button
            @click="doCancel"
            :renderStyle="{
              '--padding': '0 12px',
              '--width': 'max-content',
              '--height': '32px',
              '--borderRadius': '50px',
              '--background': 'rgba(255, 255, 255, 0.1)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
              '--fontColor': '#fff',
            }"
          >
            {{ $$t("create.cancel") }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import Button from "@/components/basic/button/Button.vue";
import LoaderCircle from "@/components/animation/LoaderCircle.vue";
import { $$t } from "@/i18n/i18n.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  pitem: {
    type: Object,
    default: null,
  },
  listRenderType: {
    type: String,
    default: "createdresult", // mysong, likemysong, createdresult
  },
  state:{
    type: Number,
    default: 0, // 0:未生成 1:排队中 2:生成中 3:生成成功 4, 6, 10, 11:生成失败
  }
});
const emits = defineEmits(["cancel", "restore"]);

const renderData = reactive({});

const doCancel = () => {
  emits("cancel", props.pitem);
};

const doFrom = () => {
  emits("from", props.pitem);
};

onMounted(() => {});
</script>
<style lang="scss" scope>
.audio-item-generate-box {
  padding: 6px 20px;
  // &:hover {
  //  background: rgba(255, 255, 255, 0.1);
  // }
  &.audio-item-generate-box-first {
    padding-top: 12px;
  }
  .audio-item-generate {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-radius: 12px;
    background: rgba(148, 173, 255, 0.15);
    backdrop-filter: blur(20px);
    justify-content: space-between;
  }
  .audio-item-box-loading {
    width: 20px;
    height: 20px;
    background: url(@/assets/img/loading-mini-3x.png);
    background-size: 100% 100%;
  }

  .audio-item-box-btn {
    margin-left: 8px;
  }
  .audio-item-box-waiting-text {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    min-height: 36px;
    color: #94adff;
    padding: 0 10px;
    display: flex;
    align-items: center;
  }
  &.audio-item-generate-box--mobile {
    padding: 6px 16px;
    .audio-item-generate {
      padding: 10px 12px;
    }
    .audio-item-box-waiting-text {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
